import { recordEvent } from '@shared/utils/logger';

const EVENT_TYPE = 'CreateWeddingFlow';

type FlowAction =
  | 'AccountCreated'
  | 'AccountCreateFailed'
  | 'SignInCompleted'
  | 'SignInFailed'
  | 'PasswordResetRequested'
  | 'PasswordResetFailed'
  | 'SocialInterceptCtaClicked'
  | 'ExistingWeddingDetected'
  | 'FormSubmitted'
  | 'EventCreated'
  | 'EventCreateFailed'
  | 'RedirectInitiated'
  | 'ErrorRetryClicked'
  | 'ErrorStartOverClicked'
  | 'WebsiteV2ChoiceShown'
  | 'WebsiteV2BetaChosen'
  | 'WebsiteV2ChoiceSkipped'
  | 'WebsiteV2ClassicChosen'
  | 'WebsiteV2RunStarted';

type FlowEventAttributes = Readonly<{
  action: FlowAction;
  errorMessage?: Maybe<string>;
  socialProvider?: Maybe<string>;
  venueProvided?: Maybe<boolean>;
  dateProvided?: Maybe<boolean>;
  lastNameProvided?: Maybe<boolean>;
  eventId?: Maybe<string>;
  website?: Maybe<string>;
  adminOrOwnerEventCount?: Maybe<number>;
  durationDays?: Maybe<number>;
  errorType?: Maybe<string>;
  statusCode?: Maybe<number>;
  isTimeout?: Maybe<boolean>;
  isHtmlResponse?: Maybe<boolean>;
  /** Which onboarding pilot arm the visitor saw ('off' | 'templates' | 'ai'). */
  websiteV2Variant?: Maybe<string>;
  /** Set on WebsiteV2RunStarted for a template clone; null = the AI path. */
  templateId?: Maybe<string>;
}>;

export function recordCreateWeddingFlowEvent(attributes: FlowEventAttributes): void {
  recordEvent(EVENT_TYPE, attributes);
}
